import { render, staticRenderFns } from "./Selfie.vue?vue&type=template&id=14d2f604&scoped=true&lang=pug&"
import script from "./Selfie.vue?vue&type=script&lang=js&"
export * from "./Selfie.vue?vue&type=script&lang=js&"
import style0 from "./Selfie.vue?vue&type=style&index=0&id=14d2f604&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d2f604",
  null
  
)

export default component.exports